import { useState } from 'react';

import { cn, getPublicImagePath } from 'lib/helpers/utility';

import Loader from 'components/shared/Loader/Loader';

const PracticeLogo = ({ image, practiceId, alt = 'Practice logo', className = '' }) => {
  const [hasError, setHasError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const handleError = () => {
    setHasError(true);
    setIsLoading(false);
  };

  const handleLoad = () => {
    setIsLoading(false);
  };

  if (!image || hasError) {
    return null;
  }

  return (
    <div className="relative">
      {isLoading && (
        <div
          className={cn(
            'bg-gray-50 absolute inset-0 flex items-center justify-center print:hidden',
            className
          )}>
          <Loader color="neutral" shade={300} size={24} />
        </div>
      )}
      <img
        src={getPublicImagePath(image, practiceId)}
        alt={alt}
        className={className}
        onError={handleError}
        onLoad={handleLoad}
        style={{ display: isLoading ? 'none' : 'block' }}
      />
    </div>
  );
};

export default PracticeLogo;
